var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',[_c('el-header',{staticStyle:{"padding":"0","margin":"0"}},[_c('toubu')],1),_c('el-main',{staticStyle:{"padding":"0px","margin-top":"22px","padding-bottom":"0px"}},[_c('div',[_c('router-view')],1)]),_c('el-footer',{staticStyle:{"padding":"0","margin":"0"}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }